import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'Arrow2LeftIcon',
  'arrow-2-left',
  'M360.294 590.996c19.995 19.995 19.995 52.413 0 72.408s-52.413 19.995-72.408 0l-162.918-162.917c-29.992-29.992-29.992-78.619 0-108.612l162.918-162.918c19.995-19.994 52.412-19.994 72.408 0s19.995 52.413 0 72.407l-95.43 95.432h605.531c28.278 0 51.2 22.922 51.2 51.2s-22.922 51.201-51.2 51.201h-601.902l91.801 91.801z',
)
